import React from 'react';

import { Container, Grid } from '@material-ui/core';
import './../../../styles/global.scss';
import './styles/dashboard.scss';
import DashboardRoutes from '../DashboardRoutes';
import Header from './Header';
import NavBar from './NavBar';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  containerPage: {
    backgroundColor: "white",
    minHeight: "43em"
  }
}));

function Dashboard(props) {
  const classes = useStyles();
  return (
    <div>      
      <Container maxWidth={'lg'}>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="flex-start"
          style={{position: 'relative'}}
        >
          {/* Postion absolute with Grid */}
          <Grid container item xs={2} style={ { minWidth: "8em"}} >
            <NavBar/>
          </Grid>

          {/* Container */}
          <Grid container item xs={10} >
            <Header />            
            <DashboardRoutes className={classes.containerPage}/>
          </Grid>
        </Grid>
      </Container>
    </div>
    
  )
}

export default Dashboard;